<template>
    <div>
        <UploadButton
            ref="uploadButton"
            v-if="!hideUploadButton"
            :postMaxSize="postMaxSize"
            :uploadMaxSize="uploadMaxSize"
            :maxFileUploads="maxFileUploads"
            :defaultMessage="defaultMessage"
            :relatedPicName="relatedPicName"
            :pics="pics"
            :compressedImg="compressedImg"
            @onChangePics="onChangePics($event)"
        />
        <UploadList
            :pics="pics"
            :inputName="inputName"
            :hideListButtonKeys="hideListButtonKeys"
        />
    </div>
</template>

<script>
import UploadButton from "FF/Vue/Common/Upload/UploadPic/UploadButton";
import UploadList from "FF/Vue/Common/Upload/UploadPic/UploadList";

export default {
    props: {
        hideUploadButton: {
            type: Boolean,
            default: false,
        },
        inputName: {
            type: String,
            default: ''
        },
        relatedPicName: {
            type: String,
            default: ''
        },
        postMaxSize: {
            type: Number,
            default: 0
        },
        uploadMaxSize: {
            type: Number,
            default: 0
        },
        maxFileUploads:  {
          type: Number,
          default: 0
        },
        picDatas: {
            type: Array,
            default: () => {
                return []
            }
        },
        defaultMessage: {
            type: String,
            default: ''
        },
        hideListButtonKeys: {
          type: Array,
          default: () => {
            return []
          }
        },
        compressedImg: {
          type: Boolean,
          default: true,
        },
    },
    data: function() {
        return {
            pics: []
        };
    },
    components: {
        UploadButton,
        UploadList,
    },
    computed: {
    },
    methods: {
        onChangePics( value ) {
            this.pics = value;
            this.$emit('onChangePics', value); // 發送事件
        },
        clearPics() {
            this.pics = [];
            this.$refs.uploadButton.resetInput();
        },
    },
    mounted: function () {
        this.pics = this.picDatas || [];
    }
};
</script>
